module.exports = __webpack_public_path__ + "img/adbig.3428bd6c.svg";